$(document).ready(function(){

  setInterval(function() {
    checkNext();
  }, 1000);

  $('.welcome_section .step_container .fieldset_wrapper .i_agree_container input[type="checkbox"]').on('change', function() {

    if($(this).is(':checked') ){
      $('.fieldset_wrapper .i_agree_container .hs-error-msgs-pp').addClass('hidden');
    } else {
      $('.fieldset_wrapper .i_agree_container .hs-error-msgs-pp').removeClass('hidden');
    }
  });

  var formSubmitted_8 = false;
  var existSubmitted_8 = setInterval(function() {
    if ( !formSubmitted_8 &&  $('.hbspt-form .submitted-message').length > 0 ) { 
      if ( $('.hbspt-form .submitted-message').length > 0 ) {
        $('.steps_section').addClass('hidden');
        $('.section_submitted').show();
      }

	    clearInterval(existSubmitted_8);
    }
  }, 500);
  
  var formHbspt_7 = false;
  var existFormhbspt_7 = setInterval(function() {
    if ( !formHbspt_7 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 

      formHbspt_7 = true;
      $('.step_container.step-final-8 .button_next_previous a.submit_page').on('click', function(e){
        e.preventDefault();
        $(this).html('Submitting...');
        $('.hbspt-form form.hs-form .hs_submit.hs-submit .actions .hs-button').trigger('click');
      });

      
      // console.log('loaded yes -------------------------------------');

	    clearInterval(existFormhbspt_7);
    } else {
      // console.log('loaded no-------------------------------------');
    }
  }, 500);

  var formHbspt_9 = false;
  var existFormhbspt_9 = setInterval(function() {
    if ( !formHbspt_9 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 

      
      formHbspt_9 = true;

      $('.step_container.step-final-14 .button_next_previous a.submit_page').on('click', function(e){
        e.preventDefault();
        $(this).html('Submitting...');
        $('.hbspt-form form.hs-form .hs_submit.hs-submit .actions .hs-button').trigger('click');
      });

	    clearInterval(existFormhbspt_9);
    }
  }, 500);

  $('.close_popup_video').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('video_play');

    $('.video_popup_content--container .video_popup_content').html('');
  });

  $('.note_notsure .show_video').on('click', function(e){
    e.preventDefault();
    $('body').addClass('video_play');

    $('.video_popup_content--container .video_popup_content').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/vMtFfj2Y1qw?si=HbucKqvBKVN2XPnu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
  });


// step 1
  $('.welcome_section .button_wrapper a').on('click', function(e){
    e.preventDefault();

    $('.welcome_section input').each(function() {
      let $input = $(this);
      let value = $input.val();

      if( value == ""){
        $input.closest('.field_content').find('div.hs-error-msgs').remove();
        $input.after('<div class="hs-error-msgs">*Please complete this required field.</div>');
        $input.addClass('error');
      }

      $('.hbspt-form input[name="'+$input.attr('name')+'"]').val(value).trigger('change');
    });

    var is_agree = true;
    if(!$('.welcome_section .step_container .fieldset_wrapper .i_agree_container input[type="checkbox"]').is(':checked') ){
      is_agree = false;
    }

    setTimeout(function() {
      
      if ($('.welcome_section .hs-error-msgs').length === 0 && is_agree ) {
        $('.welcome_section').addClass('hidden');
        $('.banner').addClass('hidden');

        $('.steps_section .step_container.step-2').addClass('active');

        top_page();
      }

    }, 500);

    
  });
  

// step 2
  var formHbspt_2 = false;
  var existFormhbspt_2 = setInterval(function() {
    if ( !formHbspt_2 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      formHbspt_2 = true;

      $('.step_container.step-2 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
        e.preventDefault();

        var data_label = $(this).data('label');
        var data_id = $(this).data('id');

        $(this).closest('.step_container').find('.field_content').removeClass('selected');
        $(this).addClass('selected');

        var $next = $(this).closest('.step_container').find('.next_page');
        $next.data('page', data_id).attr('data-page', data_id);
        $next.removeClass('disabled');

        // $(this).closest('.step_container').find('.next_page').data('page', data_id).removeClass('disabled');

        $('.step_container.step-4 .button_next_previous .back_page').data('page', data_id).attr('data-page', data_id);

        var text = $(this).find('.field_label p strong').text().trim();
        $('.hbspt-form input[name="what_power_do_you_use_in_your_house_text"]').val(text).trigger('change');

        // if( data_id === '3-single-phase'){
        //   // $('#what_power_do_you_use_in_your_house0-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#what_power_do_you_use_in_your_house0-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);


        // } else if( data_id === '3-three-phase'){
        //   // $('#what_power_do_you_use_in_your_house1-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#what_power_do_you_use_in_your_house1-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);
        // }

        // 
    // 
      });
	    clearInterval(existFormhbspt_2);
    }
  }, 500);

  // step 6
  var formHbspt_6 = false;
  var existFormhbspt_6 = setInterval(function() {
    if ( !formHbspt_6 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      
      formHbspt_6 = true;

      $('.step_container.step-6 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
        e.preventDefault();

        var text = $(this).find('.field_label').text().trim().toLowerCase().replace(/['\s.-]/g, "_");

        $(this).closest('.step_container').find('.field_content').removeClass('selected');
        $(this).addClass('selected');

        var text = $(this).find('.field_label').text().trim();
        $('.hbspt-form input[name="main_switchboard_distance_text"]').val(text).trigger('change');


        // console.log(text);

        // $('#main_switchboard_distance3-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        
        // if(text === "within_5_metres"){
        //   // $('#main_switchboard_distance0-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#main_switchboard_distance0-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);
        // } else if(text === "5_10_metres"){
        //   // $('#main_switchboard_distance1-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#main_switchboard_distance1-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);
        // } else if(text === "10_25_metres"){
        //   // $('#main_switchboard_distance2-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#main_switchboard_distance2-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);
        // } else if(text === "more_than_25_metres"){
        //   // $('#main_switchboard_distance3-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
        //   setTimeout(function() {
        //     const $radio = $('#main_switchboard_distance3-7a92f35f-2c21-4449-8a4f-2e464cb41848');
        //     if (!$radio.prop('checked')) {
        //         $radio.prop('checked', true).trigger('change');
        //     } else {
        //         $radio.trigger('click');
        //     }
        //   }, 1000);
        // }

        // var map = {
        //   "within_5_metres": "#main_switchboard_distance0-7a92f35f-2c21-4449-8a4f-2e464cb41848",
        //   "5_10_metres": "#main_switchboard_distance1-7a92f35f-2c21-4449-8a4f-2e464cb41848",
        //   "10_25_metres": "#main_switchboard_distance2-7a92f35f-2c21-4449-8a4f-2e464cb41848",
        //   "more_than_25_metres": "#main_switchboard_distance3-7a92f35f-2c21-4449-8a4f-2e464cb41848"
        // };

        // if (map[text]) {
        //     var $target = $(map[text]);
        //     var radioName = $target.attr('name');

        //     console.log(radioName);
            
        //     $('input[name="' + radioName + '"]').each(function(){
        //         $(this).prop('checked', false);
        //         radioLock6[$(this).attr('id')] = false;
        //     });
            
        //     if (!radioLock6[$target.attr('id')]) {
        //         $target.prop('checked', true).trigger('change');
        //         radioLock6[$target.attr('id')] = true;

        //         console.log($target.attr('id'));
        //     }
        // }

      });
	    clearInterval(existFormhbspt_6);
    }
  }, 500);

// step 7
  var formHbspt_5 = false;
  var existFormhbspt_5 = setInterval(function() {
    if ( !formHbspt_5 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      
      formHbspt_5 = true;

      $('.step_container.step-7 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
        e.preventDefault();

        var text = $(this).find('.field_label').text().trim().toLowerCase().replace(/['\s.-]/g, "_")

        $(this).closest('.step_container').find('.field_content').removeClass('selected');
        $(this).addClass('selected');
        
        var $next = $(this).closest('.step_container').find('.next_page');

        $(this).parent().find('.option_selection_warning').addClass('hidden');
        $(this).next('.option_selection_warning').removeClass('hidden');

        var text_label = $(this).find('.field_label').text().trim();
        $('.hbspt-form input[name="installation_text"]').val(text_label).trigger('change');

        // console.log(text);

        if(text === "i_m_in_no_rush_to_install"){
            $next.data('page', 'final-8').attr('data-page', 'final-8');
            // $('#installation0-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
            // setTimeout(function() {
            //   const $radio = $('#installation0-7a92f35f-2c21-4449-8a4f-2e464cb41848');
            //   if (!$radio.prop('checked')) {
            //       $radio.prop('checked', true).trigger('change');
            //   } else {
            //       $radio.trigger('click');
            //   }
            // }, 1000);
        } else if(text === "i_want_a_speedy_installation__let_s_go"){
            $next.data('page', '8').attr('data-page', '8');
            // $('#installation1-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
            // setTimeout(function() {
            //   const $radio = $('#installation1-7a92f35f-2c21-4449-8a4f-2e464cb41848');
            //   if (!$radio.prop('checked')) {
            //       $radio.prop('checked', true).trigger('change');
            //   } else {
            //       $radio.trigger('click');
            //   }
            // }, 1000);
        }

      });
	    clearInterval(existFormhbspt_5);
    }
  }, 500);

// step 13
var formHbspt_10 = false;
var existFormhbspt_10 = setInterval(function() {
  if ( !formHbspt_10 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
    formHbspt_10 = true;
    $('.step_container.step-13 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
      e.preventDefault();

      var text = $(this).find('.field_label').text().trim().toLowerCase();

      $(this).closest('.step_container').find('.field_content').removeClass('selected');
      $(this).addClass('selected');
      
      var $next = $(this).closest('.step_container').find('.next_page');

      var text_label = $(this).find('.field_label').text().trim();
      $('.hbspt-form input[name="existing_solar_inverter_text"]').val(text_label).trigger('change');

      if(text === "yes"){
          $next.data('page', '13-yes').attr('data-page', '13-yes');
          // $('#existing_solar_inverter0-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');

          // setTimeout(function() {
          //   const $radio = $('#existing_solar_inverter0-7a92f35f-2c21-4449-8a4f-2e464cb41848');
          //   if (!$radio.prop('checked')) {
          //       $radio.prop('checked', true).trigger('change');
          //   } else {
          //       $radio.trigger('click');
          //   }
          // }, 1000);

      } else if(text === "no"){
          $next.data('page', 'final-14').attr('data-page', 'final-14');
          // $('#existing_solar_inverter1-7a92f35f-2c21-4449-8a4f-2e464cb41848').prop('checked', true).trigger('change');
          
          // setTimeout(function() {
          //   const $radio = $('#existing_solar_inverter1-7a92f35f-2c21-4449-8a4f-2e464cb41848');
          //   if (!$radio.prop('checked')) {
          //       $radio.prop('checked', true).trigger('change');
          //   } else {
          //       $radio.trigger('click');
          //   }
          // }, 1000);
      }
    });
    
    clearInterval(existFormhbspt_10);
  }
}, 500);

// product inverter / installation
  $('.inverter_select .field_content.option_select.radio_select').on('click', function(e){
    e.preventDefault();

    $(this).closest('.step_container .fieldset_wrapper').find('.field_content').removeClass('selected');
    $(this).addClass('selected');
  });

   $('.installation_select .field_content.option_select.radio_select').on('click', function(e){

    if ($(e.target).closest('.installation_details .installation_icon').length) {
        return;
    }

    e.preventDefault();

    $(this).closest('.step_container .fieldset_wrapper').find('.field_content').removeClass('selected');
    $(this).addClass('selected');
  });

  $('.installation_select .field_content.option_select.radio_select .installation_details .installation_icon').on('click', function(e){
    e.preventDefault();

    var zoom_source =  $(this).data('zoom');

    $('body').addClass('video_play');

    $('.video_popup_content--container .video_popup_content').html('<img src="'+zoom_source+'" />')
  });

// product select
  choose_product();

// edit product
  $('.field_content.selected_battery .edit_product').on('click', function(e){
    e.preventDefault();

    var data_source = $(this).data('source');

    $(this).closest('.step_container').removeClass('active');
    $('.steps_section .step_container.step-'+data_source).addClass('active');

    
    top_page();
  });

  // back product
  $('.button_wrapper.back_continue a.back_page').on('click', function(e){
    e.preventDefault();

    var data_source = $(this).data('source');

    $(this).closest('.step_container').removeClass('active');
    $('.steps_section .step_container.step-'+data_source).addClass('active');

    
    top_page();
  });

// product inverter / installation continue
  var formHbspt_4 = false;
  var existFormhbspt_4 = setInterval(function() {
    if ( !formHbspt_4 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      
      formHbspt_4 = true;

      $('.button_wrapper .continue_inverter_intstallation').on('click', function(e){
        e.preventDefault();

        // inverter
        var selected_inverter = 0;
        var parent_class = $(this).parent().parent().attr('class').replace("active","").replace(" ",".");
        // console.log(parent_class);

        $('.'+parent_class+' .fieldset_wrapper.inverter_select .field_content.option_select.radio_select').each(function() {
          if ($(this).hasClass('selected')) {
              selected_inverter++;
          }
        });

        // installation
        var selected_installation = 0;
        $('.'+parent_class+' .fieldset_wrapper.installation_select .field_content.option_select.radio_select').each(function() {
          if ($(this).hasClass('selected')) {
              selected_installation++;
          }
        });

        if( selected_inverter > 0 && selected_installation > 0){
          clear_selected_product();

          var selected_product = localStorage.getItem('ecomm_selected_product');
          var data_return = $(this).data('return');

          
          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.radio_select.product_not_sure').removeClass('selected');

          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection').removeClass('selected');
          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection').removeClass('recommended');
          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection .product_badge span').html('');

          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection.'+selected_product).addClass('selected');
          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection.'+selected_product+' .product_badge span').html('Selected');
          $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection.'+selected_product+' .product_footer .product_select .btn_choose').html('Change product');

          $(this).closest('.step_container').removeClass('active');
          // $('.steps_section .step_container.step-'+data_return).addClass('active');
          $('.steps_section .step_container.step-4').addClass('active');

          $('.step_container.step-'+data_return+' .summary_selected_product').removeClass('hidden');
          

          var summary_selected_inverter = $('.step_container.step-'+selected_product+' .inverter_select .field_content.option_select.radio_select.selected').data('label');
          var summary_selected_installation = $('.step_container.step-'+selected_product+' .installation_select .field_content.option_select.radio_select.selected p strong').text();
          var summary_selected_installation_image = $('.step_container.step-'+selected_product+' .installation_select .field_content.option_select.radio_select.selected .installation_icon').html();

          $('.step_container.step-'+data_return+' .summary_selected_product .field_content.option_select.radio_select.installation.selected_battery .installation_icon').html(summary_selected_installation_image);
          $('.step_container.step-'+data_return+' .summary_selected_product .field_content.option_select.radio_select.installation.selected_battery p span').html(summary_selected_inverter);
          $('.step_container.step-'+data_return+' .summary_selected_product .field_content.option_select.radio_select.installation.selected_battery p strong').html(summary_selected_installation);

          $('.step_container.step-'+data_return+' .summary_selected_product .field_content.option_select.radio_select.installation.selected_battery .edit_product').data('source', selected_product);

          var save_selected_inverter = $('.step_container.step-'+selected_product+' .inverter_select .field_content.option_select.radio_select.selected .field_label p strong').text().trim();
          var save_selected_installation = $('.step_container.step-'+selected_product+' .installation_select .field_content.option_select.radio_select.selected p strong').text().trim();
          var s_selected_products = $('.step_container.step-'+data_return+' .fieldset_wrapper .field_content.option_select.product_selection.'+selected_product+' .product_title').text().trim();
          
          $('.hbspt-form input[name="inverter_size"]').val(save_selected_inverter).trigger('change');
          $('.hbspt-form input[name="installation_setup"]').val(save_selected_installation).trigger('change');
          $('.hbspt-form input[name="battery_system"]').val(s_selected_products).trigger('change');

          // console.log(data_return);

          
          $('.'+parent_class+' .product_selection_error').addClass('hidden');

          top_page();
        } else {
          $('.'+parent_class+' .product_selection_error').removeClass('hidden');
        }
        
      });
      clearInterval(existFormhbspt_4);
    }
  }, 500);

// option select
// step 5
  $('.step_container.step-5 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
    e.preventDefault();

    $(this).closest('.step_container').find('.field_content').removeClass('selected');
    $(this).addClass('selected');

    $('.step_container.step-5 .showThumb').html('');
    $('.step_container.step-5 .thumb_cnt_container').addClass('hidden');
    checkuploaded('.form_container.form_step_5');
  });

// step 12
  $('.step_container.step-12 .fieldset_wrapper .field_content.option_select.radio_select').on('click', function(e){
    e.preventDefault();

    $(this).closest('.step_container').find('.field_content').removeClass('selected');
    $(this).addClass('selected');

    $('.step_container.step-12 .showThumb').html('');
    $('.step_container.step-12 .thumb_cnt_container').addClass('hidden');
    checkuploaded('.form_container.form_step_12');
  });


// product not sure
  $('.step_container .field_content.option_select.radio_select.product_not_sure').on('click', function(e){
    e.preventDefault();

    $(this).addClass('selected');
    
    localStorage.setItem('ecomm_selected_product', 'product_not_sure');

    clear_selected_product();
  });

// previous
  $('.button_next_previous .back_page').on('click', function(e){
    e.preventDefault();

    var step = $(this).data('page');

    if( step == '1'){
      $('.welcome_section').removeClass('hidden');
      $('.banner').removeClass('hidden');

      $(this).closest('.step_container').removeClass('active');
    } else {
      $(this).closest('.step_container').removeClass('active');
      $('.steps_section .step_container.step-'+step).addClass('active');
    }

    reset_carousel();
    top_page();
  });

// next
  $('.button_next_previous .next_page').on('click', function(e){
    e.preventDefault();

    var step = $(this).data('page');

    console.log(step);

    $(this).closest('.step_container').removeClass('active');
    $('.steps_section .step_container.step-'+step).addClass('active');

    
    reset_carousel();
    top_page();
  });

  $('[data-dropdown-button]').click(function(e) {
    e.preventDefault();
    $(this).next('.dropdown-menu').toggleClass('active');
    $(this).next('.dropdown-menu').parent().toggleClass('dd_open');
  });
  
  $(document).click(function(e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("custom-dropdown")) {
      $('.dropdown-menu').removeClass('active');
      $('.dropdown-menu').parent().removeClass('dd_open'); 
    }
  });

  $('.dropdown-option').click(function(e) {
    e.preventDefault();
    var selectedText = $(this).html();
    $(this).closest('.custom-dropdown').find('.dropdown-trigger').html(selectedText);
    $(this).closest('.dropdown-menu').removeClass('active');
    $(this).closest('.dropdown-menu').parent().removeClass('dd_open');
  });


  $(".image_carousel--wrapper.three-phase").slick({
    dots: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    responsive: [
      {
          breakpoint: 989,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
          }
      }
    ]
  });

  $(".image_carousel--wrapper.product_details_gallery_wrapper").slick({
    dots: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
          breakpoint: 989,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
          }
      }
    ]
  });

// uploads
  $(".step_container .form_container .upload_area").on("dragover", function(e) {
    e.preventDefault();
    $(this).addClass("drag_over");
    return false;
  });

  $(".step_container .form_container .upload_area").on("dragleave", function(e) {            
    e.preventDefault();
    $(this).removeClass("drag_over");
    return false;
  });

  $(".step_container .form_container .upload_area").on("click", function(e) {
    e.preventDefault();
    var input_id = $(this).parent().find('input[type="file"]').attr('id');



    file_explorer(input_id, $(this).data("limit"), $(this).data("image"), $(this).data("video"), $(this).data("imagelimit"), $(this).data("videolimit"));
  });

   $(".step_container .form_container .upload_area").on("drop", function(e) {
    e.preventDefault();
    $(this).removeClass("drag_over");
    var formData = new FormData();
    var files = e.originalEvent.dataTransfer.files;
    for (var i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
    }

    uploadFormData(formData);
  });

  var formHbspt_1 = false;
  var existFormhbspt_1 = setInterval(function() {
    if ( !formHbspt_1 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      formHbspt_1 = true;

      let typingTimer_phone;
      const typingDelay_phone = 500;
      $('input[name="mobile_number"]').on('input change blur keyup paste', function(){
        clearTimeout(typingTimer_phone);

        let $input = $(this);
        let value = $input.val();

        if(value == "") {
          $input.closest('.field_content').find('div.hs-error-msgs').remove();
          $input.after('<div class="hs-error-msgs">*Please complete this required field.</div>');

        } else {
          typingTimer_phone = setTimeout(function () {
              let isValid = isValidAustralianMobile(value);
              if(!isValid ){
                $input.closest('.field_content').find('div.hs-error-msgs').remove();

                $input.after('<div class="hs-error-msgs">*Please enter a valid Australian mobile number.</div>');
                $input.addClass('error');
              } else {
                $input.closest('.field_content').find('div.hs-error-msgs').remove();
                $input.removeClass('error');
                $('.hbspt-form input[name="mobilephone"]').val(value).trigger('change');
              }
          }, typingDelay_phone);
        }
      });

      let typingTimer_zip;
      const typingDelay_zip = 500;

      $('input[name="zip"]').on('input change blur keyup paste', function(){
        clearTimeout(typingTimer_zip);

        let $input = $(this);
        let value = $input.val();

        if(value == ""){
          $input.closest('.field_content').find('div.hs-error-msgs').remove();
          $input.after('<div class="hs-error-msgs">*Please complete this required field.</div>');
        } else {
          typingTimer_zip = setTimeout(function () {
              let isValid = isValidAustralianPostcodeNSW(value);
              if(isValid == "0" ){
                $input.closest('.field_content').find('div.hs-error-msgs').remove();
                $input.after('<div class="hs-error-msgs">Sorry, this offer is currently limited to eligible areas within NSW.</div>');
                $input.addClass('error');
              } else {
                $input.closest('.field_content').find('div.hs-error-msgs').remove();
                $input.removeClass('error');

                $('.hbspt-form input[name="zip"]').val(value).trigger('change');
              }
          }, typingDelay_zip);
        }
      });

      let typingTimer;
      const typingDelay = 500;

      $('input').not('[name="zip"], [name="mobile_number"], [name="email"], [type="file"]').on('input change blur keyup paste', function(){
        clearTimeout(typingTimer);

        let $input = $(this);
        let value = $input.val();

        if(value == ""){
          $input.closest('.field_content').find('div.hs-error-msgs').remove();
          $input.after('<div class="hs-error-msgs">*Please complete this required field.</div>');
        } else {
          typingTimer = setTimeout(function () {
            $input.closest('.field_content').find('div.hs-error-msgs').remove();
            $input.removeClass('error');
            
            $('.hbspt-form input[name="'+$input.attr('name')+'"]').val(value).trigger('change');
          }, typingDelay);
        }
      });
      
      let typingTimer_email;
      const doneTypingInterval = 500;
      $('.field_content input[name="email"]').on('input change blur keyup paste', function() {
        clearTimeout(typingTimer_email);

        const $input = $(this);

        if($input.val() == ''){
          $input.after('<div class="hs-error-msgs">*Please complete this required field.</div>');
        }

          typingTimer_email = setTimeout(function () {
          const email = $input.val();

          $('.hbspt-form input[name="email"]').val(email).trigger('change');

          setTimeout(function() {
            var email_error = $('.hbspt-form .hs_email .hs-error-msgs .hs-error-msg').html();
            
            if (typeof email_error === "undefined") {
              $input.closest('.field_content').find('div.hs-error-msgs').remove();
            } else {
              $input.closest('.field_content').find('div.hs-error-msgs').remove();
              $input.after('<div class="hs-error-msgs">'+email_error+'</div>');
            }
          }, 1500);
          
        }, doneTypingInterval);
      });

      clearInterval(existFormhbspt_1);
    }
  }, 500);

});

function top_page(){
  // $('html, body').animate({ scrollTop: 0 }, 600);
  $('html, body').scrollTop(0);
}

function reset_carousel(){
  $(".image_carousel--wrapper.three-phase").slick('setPosition');

  choose_product();
}

function reset_carousel_gallery(){
  $(".image_carousel--wrapper.product_details_gallery_wrapper").slick('setPosition');
}

function choose_product(){
  $('.product_select .btn_choose').on('click', function(e){
    e.preventDefault();

    var data_product = $(this).data('product');
    localStorage.setItem('ecomm_selected_product', data_product);

    var data_action = $(this).data('action');

    if(data_action == 'choose'){
      $(this).closest('.step_container').removeClass('active');
      $('.steps_section .step_container.step-'+data_product).addClass('active');
    } else {
      $(this).closest('.step_container').removeClass('active');
      $('.steps_section .step_container.step-'+data_product).addClass('active');
       $('.steps_section .step_container.step-'+data_product+' .button_wrapper .continue_inverter_intstallation').trigger('click');
    }
    
    top_page();
  });

  $('.product_select .link_details').on('click', function(e){
    e.preventDefault();

    var data_view = $(this).data('view');

    $(this).closest('.step_container').removeClass('active');
    $('.steps_section .step_container.step-'+data_view).addClass('active');
    
    reset_carousel_gallery();
    top_page();
  });

  $('.pd_top .back_view .back_page').on('click', function(e){
    e.preventDefault();

    var data_view = $(this).data('previous');

    $(this).closest('.step_container').removeClass('active');
    $('.steps_section .step_container.step-'+data_view).addClass('active');
    
    top_page();
  });
}

function clear_selected_product(){
  $('.field_content.option_select.product_selection').removeClass('selected');
  $('.field_content.option_select.product_selection').removeClass('recommended'); 
  $('.field_content.option_select.product_selection .product_badge span').html('');
  $('.field_content.option_select.product_selection .product_footer .product_select .btn_choose').html('Choose product');

  $('.product_single_phase_container .fieldset_wrapper .field_content.option_select.product_selection:first-of-type').addClass('recommended');
  $('.product_single_phase_container .fieldset_wrapper .field_content.option_select.product_selection:first-of-type .product_badge span').html('');
  // $('.product_single_phase_container .fieldset_wrapper .field_content.option_select.product_selection .product_footer .product_select .btn_choose').html('Choose product');

  $('.product_three_phase_container .fieldset_wrapper .slick-slide:first-of-type .field_content.option_select.product_selection').addClass('recommended');
  $('.product_three_phase_container .fieldset_wrapper .slick-slide:first-of-type .field_content.option_select.product_selection .product_badge span').html('');
  // $('.product_three_phase_container .fieldset_wrapper .slick-slide .field_content.option_select.product_selection .product_footer .product_select .btn_choose').html('Choose product');

  $('.product_single_phase_container .fieldset_wrapper.summary_selected_product').addClass('hidden');
  $('.product_three_phase_container .fieldset_wrapper.summary_selected_product').addClass('hidden');
}


function isValidAustralianMobile(number) {
  var cleaned = number.replace(/\s+/g, '').replace(/-/g, '');
  var regex = /^(?:\+?61|0)4\d{8}$/;
  return regex.test(cleaned);
}

function isValidAustralianPostcode(postcode) {

  var valid_postcode = ["221","1001","1002","1003","1004","1005","1006","1007","1008","1009","1010","1011","1020","1021","1022","1023","1025","1026","1027","1028","1029","1030","1031","1032","1033","1034","1035","1036","1037","1038","1039","1040","1041","1042","1043","1044","1045","1046","1100","1101","1105","1106","1107","1108","1109","1110","1112","1113","1114","1115","1116","1117","1118","1119","1120","1121","1122","1123","1124","1125","1126","1127","1128","1129","1130","1131","1132","1133","1134","1135","1136","1137","1138","1139","1140","1141","1142","1143","1144","1145","1146","1147","1148","1149","1150","1151","1152","1153","1154","1155","1156","1157","1158","1159","1160","1161","1162","1163","1164","1165","1166","1167","1168","1169","1170","1171","1172","1173","1174","1175","1176","1177","1178","1179","1180","1181","1182","1183","1184","1185","1186","1187","1188","1189","1190","1191","1193","1194","1195","1196","1197","1198","1199","1200","1201","1202","1203","1204","1205","1206","1207","1209","1210","1211","1212","1213","1214","1216","1217","1218","1219","1221","1222","1223","1224","1226","1227","1228","1229","1231","1232","1233","1234","1291","1292","1293","1294","1295","1296","1297","1298","1299","1401","1420","1422","1423","1424","1425","1426","1427","1428","1429","1430","1441","1476","1493","1582","1597","1639","1658","1712","1740","1741","1771","1816","1819","1830","1831","1848","1888","2000","2000","2000","2000","2000","2000","2000","2006","2007","2007","2008","2008","2009","2010","2010","2011","2011","2011","2011","2011","2015","2015","2015","2016","2017","2017","2018","2018","2019","2019","2020","2020","2020","2021","2021","2022","2022","2022","2023","2024","2024","2025","2026","2026","2026","2026","2027","2027","2027","2027","2028","2029","2030","2030","2030","2030","2030","2031","2031","2031","2031","2032","2032","2033","2034","2034","2035","2035","2035","2036","2036","2036","2036","2036","2036","2036","2036","2036","2037","2037","2038","2039","2040","2040","2041","2041","2041","2042","2042","2043","2044","2044","2044","2045","2046","2046","2046","2046","2046","2046","2046","2047","2048","2049","2049","2049","2050","2050","2052","2055","2060","2060","2060","2060","2060","2060","2061","2061","2062","2063","2064","2065","2065","2065","2065","2065","2065","2066","2066","2066","2066","2066","2066","2066","2067","2067","2068","2068","2068","2068","2068","2068","2069","2069","2069","2070","2070","2070","2071","2071","2072","2073","2073","2074","2074","2074","2074","2075","2075","2076","2076","2076","2077","2077","2077","2077","2079","2080","2081","2081","2082","2082","2083","2083","2083","2083","2083","2083","2083","2084","2084","2084","2085","2085","2085","2086","2086","2087","2087","2088","2088","2089","2089","2090","2090","2090","2092","2093","2093","2093","2093","2093","2094","2095","2095","2096","2096","2096","2097","2097","2097","2097","2099","2099","2099","2099","2100","2100","2100","2100","2100","2100","2101","2101","2101","2101","2102","2103","2104","2105","2105","2105","2105","2106","2106","2107","2107","2107","2107","2107","2107","2107","2108","2108","2108","2108","2108","2108","2109","2110","2110","2111","2111","2111","2111","2111","2111","2111","2112","2112","2112","2113","2113","2113","2113","2113","2114","2114","2114","2114","2114","2115","2116","2117","2117","2117","2117","2118","2118","2118","2118","2119","2119","2120","2120","2120","2121","2121","2122","2122","2123","2125","2126","2127","2127","2128","2130","2131","2132","2133","2133","2134","2134","2135","2136","2136","2136","2137","2137","2137","2137","2137","2138","2138","2138","2139","2140","2140","2140","2141","2141","2141","2141","2142","2142","2142","2142","2142","2142","2142","2143","2143","2143","2144","2145","2145","2145","2145","2145","2145","2145","2145","2146","2146","2146","2147","2147","2147","2147","2148","2148","2148","2148","2148","2148","2148","2150","2150","2150","2151","2151","2152","2153","2153","2153","2154","2155","2155","2155","2155","2156","2156","2156","2157","2157","2157","2158","2158","2158","2159","2159","2159","2159","2160","2160","2161","2161","2161","2161","2162","2162","2163","2163","2163","2164","2164","2164","2164","2165","2165","2165","2165","2166","2166","2166","2166","2166","2167","2168","2168","2168","2168","2168","2168","2168","2170","2170","2170","2170","2170","2170","2170","2170","2170","2170","2170","2170","2171","2171","2171","2171","2171","2172","2172","2172","2173","2173","2175","2176","2176","2176","2176","2176","2176","2176","2177","2177","2178","2178","2178","2179","2179","2190","2190","2190","2191","2192","2193","2193","2193","2194","2195","2195","2196","2196","2197","2198","2199","2199","2200","2200","2200","2200","2200","2200","2200","2203","2204","2204","2204","2205","2205","2205","2206","2206","2207","2207","2207","2207","2207","2208","2209","2209","2210","2210","2210","2210","2211","2211","2212","2212","2212","2213","2213","2213","2214","2216","2216","2216","2216","2217","2217","2217","2217","2217","2217","2218","2218","2219","2219","2219","2220","2220","2220","2221","2221","2221","2221","2221","2222","2223","2223","2224","2224","2224","2224","2225","2225","2226","2226","2226","2227","2227","2228","2228","2229","2229","2229","2229","2229","2229","2230","2230","2230","2230","2230","2231","2232","2232","2232","2232","2232","2232","2232","2232","2233","2233","2233","2233","2233","2234","2234","2234","2234","2234","2234","2234","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2250","2251","2251","2251","2251","2251","2251","2251","2251","2251","2251","2251","2251","2256","2256","2256","2256","2256","2256","2256","2256","2256","2256","2257","2257","2257","2257","2257","2257","2257","2257","2257","2257","2257","2257","2258","2258","2258","2258","2258","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2259","2260","2260","2260","2260","2260","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2261","2262","2262","2262","2262","2262","2262","2262","2262","2262","2263","2263","2263","2263","2263","2263","2263","2264","2264","2264","2264","2264","2264","2264","2264","2264","2264","2264","2264","2264","2265","2265","2267","2278","2278","2278","2280","2280","2280","2280","2280","2280","2280","2280","2281","2281","2281","2281","2281","2281","2281","2281","2281","2281","2281","2282","2282","2282","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2283","2284","2284","2284","2284","2284","2284","2284","2285","2285","2285","2285","2285","2285","2285","2286","2286","2286","2287","2287","2287","2287","2287","2287","2287","2287","2287","2289","2289","2289","2289","2289","2289","2290","2290","2290","2290","2290","2290","2290","2290","2290","2290","2291","2291","2291","2292","2292","2293","2293","2294","2295","2295","2296","2297","2298","2298","2298","2299","2299","2299","2300","2300","2300","2300","2300","2302","2303","2303","2303","2304","2304","2304","2304","2304","2304","2304","2305","2305","2305","2306","2307","2308","2308","2311","2311","2311","2311","2311","2311","2311","2311","2311","2311","2311","2312","2312","2314","2315","2315","2315","2315","2316","2316","2316","2316","2316","2316","2317","2317","2318","2318","2318","2318","2318","2318","2318","2319","2319","2319","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2320","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2321","2322","2322","2322","2322","2322","2322","2322","2322","2322","2323","2323","2323","2323","2323","2323","2323","2323","2323","2323","2323","2323","2323","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2324","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2325","2326","2326","2326","2326","2326","2326","2327","2327","2327","2328","2328","2328","2328","2328","2328","2328","2328","2328","2328","2329","2329","2329","2329","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2330","2331","2333","2333","2333","2333","2333","2333","2333","2333","2333","2333","2333","2333","2333","2333","2334","2335","2335","2335","2335","2335","2335","2335","2335","2335","2335","2336","2336","2336","2336","2336","2336","2336","2336","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2337","2338","2338","2338","2338","2338","2338","2338","2338","2338","2339","2339","2339","2339","2339","2339","2339","2339","2339","2339","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2340","2341","2342","2342","2343","2343","2343","2343","2343","2343","2343","2343","2343","2343","2343","2343","2343","2344","2344","2345","2345","2346","2346","2346","2346","2346","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2350","2351","2352","2352","2352","2352","2353","2354","2354","2354","2354","2354","2354","2354","2354","2354","2354","2354","2355","2355","2357","2357","2357","2357","2357","2357","2357","2357","2357","2358","2358","2358","2358","2358","2358","2358","2358","2365","2365","2365","2365","2365","2365","2365","2365","2365","2365","2365","2365","2365","2365","2370","2370","2370","2370","2370","2370","2370","2370","2370","2370","2370","2370","2371","2371","2372","2372","2379","2379","2379","2379","2380","2380","2380","2380","2380","2380","2380","2380","2381","2381","2381","2381","2395","2395","2395","2396","2396","2415","2415","2415","2415","2415","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2420","2421","2421","2421","2421","2421","2421","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2422","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2423","2424","2424","2424","2424","2424","2424","2424","2424","2425","2425","2425","2425","2425","2425","2426","2426","2426","2427","2427","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2428","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2429","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2430","2431","2431","2431","2439","2439","2439","2439","2439","2439","2439","2439","2439","2439","2439","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2440","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2441","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2443","2444","2444","2444","2444","2444","2444","2444","2444","2444","2444","2444","2445","2445","2445","2445","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2446","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2447","2448","2448","2448","2448","2449","2449","2449","2449","2449","2449","2449","2449","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2450","2452","2452","2452","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2453","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2454","2455","2455","2455","2455","2455","2456","2456","2456","2456","2456","2456","2456","2456","2456","2456","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2460","2462","2462","2462","2462","2462","2462","2462","2462","2462","2462","2462","2462","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2463","2464","2464","2464","2464","2464","2464","2465","2466","2466","2466","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2469","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2470","2471","2471","2471","2471","2471","2471","2471","2471","2471","2472","2472","2472","2472","2472","2472","2472","2472","2473","2473","2473","2473","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2474","2475","2475","2475","2475","2476","2476","2476","2476","2476","2476","2476","2476","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2477","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2478","2479","2479","2479","2479","2479","2479","2479","2479","2479","2479","2479","2479","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2480","2481","2481","2481","2481","2481","2481","2481","2481","2482","2482","2482","2482","2482","2482","2482","2482","2482","2482","2482","2482","2482","2483","2483","2483","2483","2483","2483","2483","2483","2483","2483","2483","2483","2483","2483","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2484","2485","2485","2486","2486","2486","2486","2486","2486","2486","2486","2486","2486","2486","2486","2486","2487","2487","2487","2487","2487","2487","2487","2487","2488","2488","2488","2489","2489","2490","2490","2500","2500","2500","2500","2500","2500","2500","2500","2500","2500","2500","2502","2502","2502","2502","2505","2505","2506","2508","2508","2508","2508","2508","2508","2508","2508","2508","2515","2515","2515","2515","2515","2515","2516","2517","2517","2517","2518","2518","2518","2518","2518","2518","2519","2519","2519","2519","2519","2519","2522","2525","2526","2526","2526","2526","2526","2526","2526","2526","2527","2527","2527","2527","2527","2527","2527","2527","2528","2528","2528","2528","2528","2528","2529","2529","2529","2529","2529","2529","2529","2530","2530","2530","2530","2530","2530","2530","2530","2530","2530","2530","2530","2530","2533","2533","2533","2533","2533","2533","2533","2533","2533","2534","2534","2534","2534","2534","2534","2534","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2535","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2536","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2537","2538","2538","2538","2538","2538","2538","2538","2538","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2539","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2540","2541","2541","2541","2541","2541","2541","2541","2541","2545","2545","2545","2545","2545","2545","2546","2546","2546","2555","2556","2557","2557","2558","2558","2558","2559","2559","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2560","2563","2564","2564","2564","2565","2565","2565","2566","2566","2566","2566","2566","2567","2567","2567","2567","2567","2567","2568","2569","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2570","2571","2571","2571","2571","2571","2571","2571","2571","2572","2572","2573","2574","2574","2574","2574","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2575","2576","2576","2576","2576","2576","2576","2576","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2577","2578","2579","2579","2579","2579","2579","2579","2579","2579","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2580","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2581","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2582","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2583","2584","2585","2586","2586","2586","2586","2586","2586","2586","2586","2586","2587","2587","2587","2587","2587","2587","2587","2587","2587","2587","2587","2588","2590","2590","2590","2590","2594","2594","2594","2594","2594","2594","2594","2594","2594","2594","2594","2594","2594","2600","2600","2600","2600","2600","2600","2600","2600","2600","2600","2600","2601","2601","2601","2602","2602","2602","2602","2602","2602","2602","2603","2603","2603","2603","2604","2604","2604","2605","2605","2605","2606","2606","2606","2606","2606","2606","2607","2607","2607","2607","2607","2609","2609","2609","2609","2609","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2611","2612","2612","2612","2612","2614","2614","2614","2614","2614","2614","2614","2614","2615","2615","2615","2615","2615","2615","2615","2615","2615","2615","2615","2615","2617","2617","2617","2617","2617","2617","2617","2617","2618","2618","2618","2618","2619","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2620","2621","2621","2621","2621","2621","2621","2621","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2622","2623","2624","2626","2626","2626","2628","2628","2628","2628","2629","2629","2629","2629","2629","2629","2629","2629","2629","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2630","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2640","2641","2641","2641","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2642","2643","2644","2644","2644","2644","2644","2644","2644","2644","2644","2645","2645","2645","2646","2646","2646","2646","2646","2646","2646","2646","2646","2646","2649","2649","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2650","2651","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2652","2653","2653","2653","2653","2653","2653","2653","2653","2653","2653","2655","2655","2655","2655","2655","2656","2656","2656","2656","2656","2656","2656","2658","2658","2658","2658","2658","2659","2659","2660","2660","2660","2661","2663","2663","2663","2663","2663","2663","2663","2663","2663","2665","2665","2665","2665","2665","2665","2665","2665","2665","2665","2665","2665","2665","2666","2666","2666","2666","2666","2666","2666","2666","2666","2666","2666","2666","2666","2666","2668","2669","2669","2669","2669","2669","2671","2671","2671","2671","2671","2671","2671","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2680","2681","2681","2700","2700","2700","2700","2700","2700","2700","2700","2700","2700","2700","2700","2700","2701","2701","2701","2701","2702","2703","2705","2705","2705","2705","2705","2705","2705","2705","2705","2705","2706","2707","2707","2710","2710","2713","2716","2716","2716","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2720","2721","2721","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2722","2725","2726","2726","2727","2727","2727","2727","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2729","2730","2730","2730","2730","2730","2745","2745","2745","2745","2745","2745","2747","2747","2747","2747","2747","2747","2747","2747","2747","2748","2749","2749","2750","2750","2750","2750","2750","2750","2750","2750","2752","2752","2753","2753","2753","2753","2753","2753","2753","2753","2753","2754","2754","2754","2755","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2756","2757","2758","2758","2758","2758","2758","2758","2758","2758","2758","2758","2758","2759","2759","2760","2760","2760","2760","2760","2760","2760","2761","2761","2761","2761","2761","2761","2762","2763","2763","2765","2765","2765","2765","2765","2765","2765","2766","2766","2767","2767","2768","2768","2768","2769","2770","2770","2770","2770","2770","2770","2770","2770","2770","2770","2770","2770","2770","2773","2773","2774","2774","2774","2774","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2775","2776","2777","2777","2777","2777","2777","2777","2778","2778","2778","2779","2780","2780","2780","2780","2782","2783","2784","2785","2785","2786","2786","2786","2786","2786","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2787","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2790","2791","2791","2792","2792","2793","2793","2793","2793","2794","2794","2794","2794","2794","2794","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2795","2797","2797","2798","2798","2798","2798","2798","2798","2798","2799","2799","2799","2799","2799","2799","2799","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2800","2803","2803","2803","2804","2804","2804","2804","2805","2806","2806","2807","2808","2809","2810","2810","2810","2810","2810","2810","2810","2810","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2820","2821","2821","2823","2823","2823","2823","2823","2824","2827","2827","2827","2827","2827","2827","2827","2828","2828","2828","2828","2828","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2830","2831","2831","2831","2831","2831","2831","2831","2831","2831","2831","2831","2831","2831","2831","2842","2842","2842","2842","2843","2844","2844","2844","2845","2846","2846","2846","2846","2847","2848","2848","2848","2848","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2849","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2850","2852","2852","2852","2852","2852","2852","2852","2852","2852","2852","2852","2852","2864","2864","2864","2864","2864","2865","2865","2865","2865","2866","2866","2866","2866","2866","2866","2866","2866","2867","2867","2867","2867","2868","2868","2868","2868","2869","2869","2869","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2870","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2871","2873","2873","2874","2874","2875","2875","2875","2875","2875","2875","2876","2876","2876","2876","2877","2877","2899","2900","2900","2902","2903","2903","2903","2904","2904","2904","2904","2905","2905","2905","2905","2905","2905","2905","2906","2906","2906","2911","2911","2912","2913","2913","2913","2913","2913","2914","2914","2914","2914"];

  if (valid_postcode.includes(postcode) || ( postcode >= 2000 && postcode <= 2999 )) {
    return "1";
  } else {
    return "0";
  }
}


function file_explorer(input_id, maxFiles, accept_image, accept_video, image_limit, video_limit) {
  document.getElementById(input_id).click();
  document.getElementById(input_id).onchange = function() {
    files = document.getElementById(input_id).files;
    var formData = new FormData();
    
    var  allFiles = 0;
    var  file_uploaded_container = $(this).parent().find('.showThumb');
    
    if( !file_uploaded_container.is(':empty') ){
      allFiles = $(this).parent().find('.showThumb .uploaded_file').length;
    }

    const  remaining = (maxFiles - allFiles);

    
    $(this).parent().find('.error_upload').html("");

    if (files.length > remaining) {
      $(this).parent().find('.error_upload').html("<span>You've exceeded the allowed number of files. Only "+maxFiles+" uploads are permitted.</span>");
    } else {
      // var parent_parent_class = $(this).parent().parent().attr('class');
      var allowed_exts_img = ['pdf', 'jpg', 'jpeg', 'png', 'heic', 'heif'];
      var allowed_exts_video = ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'webm', 'flv'];

      // var proceed_upload = true;

      // var check_file_extension = files[0]['name'].split('.').pop().toLowerCase();

      // if ($.inArray(check_file_extension, allowed_exts_img) !== -1) {
      //   proceed_upload = true;
      // } else {
      //   proceed_upload = false;
      // }

      $(this).parent().find('.error_upload').html("");
      

      var totalFiles = 0;
      var parent_class_top = "."+$(this).parent().parent().attr('class').replace(" ",".");
      for (var i = 0; i < files.length; i++) {

        var check_file_extension = files[i]['name'].split('.').pop().toLowerCase();

        if ($.inArray(check_file_extension, allowed_exts_img) !== -1) {
          
          var error_upload_image = false;
          if(accept_image){
            var maxSizeMBImage = 21;
            var sizeMBImage = files[i]['size'] / (1024 * 1024);

            if (sizeMBImage < maxSizeMBImage) {
              formData.append("file[]", files[i]);
              totalFiles++;
            } else {
              error_upload_image = true;
            }
          } else {
            error_upload_image = true;
          }

          if( error_upload_image){
            var errorData = '<div class="uploaded_error_file"><div class="error_file_content"><div class="error_file_name"><span class="file_name">'+files[i]['name']+' </span></span><span class="remove_file" title="remove"><svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V6H17H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H7H9V5ZM10 8H8V18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18V8H14H10ZM13 6H11V5H13V6ZM10 9C10.5523 9 11 9.44772 11 10V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V10C9 9.44772 9.44772 9 10 9ZM14 9C14.5523 9 15 9.44772 15 10V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V10C13 9.44772 13.4477 9 14 9Z" fill="#FE5900"/></svg></span></div></div></div>';

            $(parent_class_top+ ' .showErrorThumb').append(errorData);

            $(parent_class_top+" .showErrorThumb span.remove_file").on("click", function(e) {
              $(this).parent().parent().parent().remove();
              checkuploaded(parent_class_top);
            }); 

            checkuploaded(parent_class_top);

            $(this).parent().find('.upload_error_file .successfull_file_upload.image_upload').removeClass('hidden');
            $(this).parent().find('.upload_error_file .successfull_file_upload.video_upload').addClass('hidden');
          }

        } else if ($.inArray(check_file_extension, allowed_exts_video) !== -1) {

          
          var error_upload_video = false;
          if(accept_video){
              var maxSizeMBVideo = 51;
              var sizeMBVideo = files[i]['size'] / (1024 * 1024);
              if (sizeMBVideo < maxSizeMBVideo) {
                formData.append("file[]", files[i]);
                totalFiles++;
              } else {
                error_upload_video = true;
              }
          } else {
            error_upload_video = true;
          }

          if( error_upload_video ){
            var errorData = '<div class="uploaded_error_file"><div class="error_file_content"><div class="error_file_name"><span class="file_name">'+files[i]['name']+' </span><span class="remove_file" title="remove"><svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V6H17H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H7H9V5ZM10 8H8V18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18V8H14H10ZM13 6H11V5H13V6ZM10 9C10.5523 9 11 9.44772 11 10V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V10C9 9.44772 9.44772 9 10 9ZM14 9C14.5523 9 15 9.44772 15 10V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V10C13 9.44772 13.4477 9 14 9Z" fill="#FE5900"/></svg></span></div></div></div>';
            
            $(parent_class_top+ ' .showErrorThumb').append(errorData);

            $(parent_class_top+" .showErrorThumb span.remove_file").on("click", function(e) {
              $(this).parent().parent().parent().remove();
              checkuploaded(parent_class_top);
            }); 

            checkuploaded(parent_class_top);
            
            $(this).parent().find('.upload_error_file .successfull_file_upload.image_upload').addClass('hidden');
            $(this).parent().find('.upload_error_file .successfull_file_upload.video_upload').removeClass('hidden');
          }

        }
      }

      if( totalFiles > 0){
        var parent_class = "."+$(this).parent().parent().attr('class').replace(" ",".");
        uploadFormData(formData, parent_class);
      }
        
    }
  };
}

function uploadFormData(form_data, parent_class) {
  $(parent_class+' .upload_progress_bar').removeClass('hide');
  $(parent_class+' .upload_progress').css({
      "width": "0%"
  });

  $('.upload_progress span').html('0% complete');

  var formdata = form_data;
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfOBGIhAAAAAGBgUOALWAA6S-jJqhyScHA2jTAU', {
      action: 'submit'
    }).then(function(token) {
      $.ajax({
        url: "https://camping.outbax.com.au/webapp/shopify/contactus/upload_vxe.php?gv3="+token,
        method: "POST",
        data: form_data,
        contentType: false,
        cache: false,
        processData: false,
        success: function(data) {
          $(parent_class+' .upload_progress span').html('100% complete');
          
          setTimeout(function() {
            $(parent_class+' .upload_progress_bar').addClass('hide');
            $(parent_class+" .showThumb").append(data);
            $(parent_class+" .uploaded_file_name span").on("click", function(e) {
              $(this).parents(parent_class+' .uploaded_file').remove();
              checkuploaded(parent_class);
            }); 

            checkuploaded(parent_class);

            if(parent_class == '.form_container.form_step_5'){
              $('.step_container.step-5 .field_content.option_select.radio_select.share_later').removeClass('selected');
            }

            if(parent_class == '.form_container.form_step_12'){
              $('.step_container.step-12 .field_content.option_select.radio_select.share_later').removeClass('selected');
            }
          }, 500);
          $(parent_class+' .control .upload_area').removeClass('disable_upload');

          // alert(parent_class);
        },
        progress: function(e) {
          if (e.lengthComputable) {
            var pct = (e.loaded / e.total) * 99;
            $(parent_class+' .upload_progress').css({
                "width": Math.trunc(pct) + "%"
            });
            $(parent_class+' .upload_progress span').html(Math.trunc(pct) + '% complete');
            $(parent_class+' .control .upload_area').addClass('disable_upload');
          } else {
            console.warn('Content Length not reported!');
          }
        }
      });						
    });
  });	  
}

(function($, window, undefined) {
  var hasOnProgress = ("onprogress" in $.ajaxSettings.xhr());
  if (!hasOnProgress) {
      return;
  }

  var oldXHR = $.ajaxSettings.xhr;
  $.ajaxSettings.xhr = function() {
    var xhr = oldXHR();
    if (xhr instanceof window.XMLHttpRequest) {
      xhr.addEventListener('progress', this.progress, false);
    }
    if (xhr.upload) {
      xhr.upload.addEventListener('progress', this.progress, false);
    }
    return xhr;
  };
})(jQuery, window);

function checkuploaded(parent_class){
  var file_uploaded = $(parent_class + ' .showThumb .uploaded_file').length;
  var file_error_uploaded = $(parent_class + ' .showErrorThumb .uploaded_error_file').length;

  var upload_limit = $(parent_class + ' .control .upload_area').data('limit');
  if(file_uploaded >= upload_limit){
    $(parent_class + ' .control .upload_area').addClass('disable_upload');    
    $(parent_class + ' .control .upload_area .error_upload').html("<span>Maximum "+upload_limit+" files allowed. Remove a file to upload another.</span>");
  } else {
    $(parent_class + ' .control .upload_area').removeClass('disable_upload');
    $(parent_class + ' .control .upload_area .error_upload').html("");
  }

  $(parent_class + ' .upload_error').addClass('hidden');
  $(parent_class + ' .upload_error_file').addClass('hidden');

  if(file_uploaded > 0 && file_error_uploaded <= 0){

    $(parent_class + ' .upload_empty').addClass('hidden');

    $(parent_class + ' .upload_success').removeClass('hidden');
    $(parent_class + ' .upload_error').addClass('hidden');
    $(parent_class + ' .upload_error_file').addClass('hidden');
    
    if(file_uploaded > 10){
      file_uploaded = 10;
    }

    $(parent_class + ' .file_selected').html('<strong>' + file_uploaded + ' file selected<strong>');
    $(parent_class + ' .thumb_cnt_container').removeClass('hidden');
    $(parent_class + ' .thumb_cnt_container .thumb_cnt_content span').html(file_uploaded);

  } else {

    if(file_error_uploaded > 0){
      
      $(parent_class + ' .upload_empty').addClass('hidden');
      $(parent_class + ' .upload_success').addClass('hidden');
      $(parent_class + ' .upload_error').addClass('hidden');
      $(parent_class + ' .upload_error_file').removeClass('hidden');
      $(parent_class + ' .upload_error_file .file_selected').html('<strong>'+file_error_uploaded+' file selected<strong>');

      $(parent_class + ' .thumb_cnt_container').addClass('hidden');
      $(parent_class + ' .thumb_cnt_container .thumb_cnt_content span').html('0');

    } else {
      $(parent_class + ' .upload_empty').removeClass('hidden');
      $(parent_class + ' .upload_success').addClass('hidden');
      $(parent_class + ' .upload_error').addClass('hidden');
      $(parent_class + ' .upload_error_file').addClass('hidden');
      $(parent_class + ' .file_selected').html('<strong>0 file selected<strong>');

      $(parent_class + ' .thumb_cnt_container').addClass('hidden');
      $(parent_class + ' .thumb_cnt_container .thumb_cnt_content span').html('0');
    }
    
    
  } 
}


function initAutocomplete() {
  const input = document.getElementById("home_address");

  // Enable Google Places Autocomplete
  const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ["address"],
      componentRestrictions: { country: "au" } // Restrict to Australia
  });

  autocomplete.addListener("place_changed", function () {
      const place = autocomplete.getPlace();
      $('.hbspt-form input[name="address"]').val(place.formatted_address).trigger('change');
  });
}

    // Initialize on page load
    // window.onload = initAutocomplete;

var formAddress = false;
var existAddress = setInterval(function() {
  if (!formAddress && $('input[name="address"').length > 0 ) {
    formAddress = true;
    
    
    initAutocomplete();
    
    clearInterval(existAddress);
  }
}, 300);


function checkNext(){
  var formHbspt_3 = false;
  var existFormhbspt_3 = setInterval(function() {
    if ( !formHbspt_3 &&  $('#hsForm_7a92f35f-2c21-4449-8a4f-2e464cb41848').length > 0 ) { 
      formHbspt_3 = true;

      // single pahse
      if( $('.step_container.step-3-single-phase .fieldset_wrapper .field_content.option_select').hasClass('selected') ) {
        $('.step_container.step-3-single-phase .button_next_previous .next_page').removeClass('disabled');
      } else {
        $('.step_container.step-3-single-phase .button_next_previous .next_page').addClass('disabled');
      }

      // three pahse
      if( $('.step_container.step-3-three-phase .fieldset_wrapper .field_content.option_select').hasClass('selected') ) {
        $('.step_container.step-3-three-phase .button_next_previous .next_page').removeClass('disabled');
      } else {
        $('.step_container.step-3-three-phase .button_next_previous .next_page').addClass('disabled');
      }

      // product not sure
      var ls_product = localStorage.getItem('ecomm_selected_product');
      if( ls_product == 'product_not_sure'){
        $('.hbspt-form input[name="inverter_size"]').val("n/a").trigger('change');
        $('.hbspt-form input[name="installation_setup"]').val("n/a").trigger('change');
        $('.hbspt-form input[name="battery_system"]').val("I'm not sure — let an expert help me").trigger('change');
      }

      // calendar
      var selected_calendar = $('.step_container.step-4 .fieldset_wrapper .dropdown-trigger').text().trim();
      if( selected_calendar == 'Schedule Options' ){
        $('.step_container.step-4 .button_next_previous .next_page').addClass('disabled');
      } else {
        $('.step_container.step-4 .button_next_previous .next_page').removeClass('disabled');
      }
      $('.hbspt-form input[name="when_would_you_like_your_system_installed"]').val(selected_calendar).trigger('change');

      // step 5
      var step_5_files_uploaded = $('.step_container.step-5 .showThumb .uploaded_file').length;
      if( step_5_files_uploaded > 0 || $('.step_container.step-5 .fieldset_wrapper .field_content.option_select').hasClass('selected') ){
        var form_uploaded_5 = "";
        if( $('.step_container.step-5 .fieldset_wrapper .field_content.option_select.share_later').hasClass('selected') ){
          form_uploaded_5 = "I'll share this later";
        } else {
          $('.step_container.step-5 .showThumb .uploaded_file').each(function(){
            form_uploaded_5 += $(this).find('input').val()+'\n';
          });
        }

        $('.step_container.step-5 .button_next_previous .next_page').removeClass('disabled');
        $('.hbspt-form textarea[name="where_would_you_like_your_system_installed"]').val(form_uploaded_5).trigger('change');

      } else {
        $('.step_container.step-5 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="where_would_you_like_your_system_installed"]').val("n/a").trigger('change');
      }

      // step 6
      if( $('.step_container.step-6 .fieldset_wrapper .field_content.option_select').hasClass('selected') ) {
        $('.step_container.step-6 .button_next_previous .next_page').removeClass('disabled');
      } else {
        $('.step_container.step-6 .button_next_previous .next_page').addClass('disabled');
      }      
      

      // step 7
      if( $('.step_container.step-7 .fieldset_wrapper .field_content.option_select').hasClass('selected') ) {
        $('.step_container.step-7 .button_next_previous .next_page').removeClass('disabled');
      } else {
        $('.step_container.step-7 .button_next_previous .next_page').addClass('disabled');
      }

      // step 8
      var step_8_files_uploaded = $('.step_container.step-8 .showThumb .uploaded_file').length;
      if( step_8_files_uploaded > 0 ){
        $('.step_container.step-8 .button_next_previous .next_page').removeClass('disabled');

        var form_uploaded_8 = '';
        $('.step_container.step-8 .showThumb .uploaded_file').each(function(){
          form_uploaded_8 += $(this).find('input').val()+'\n';
        });
        $('.hbspt-form textarea[name="latest_electricity_bill_images"]').val(form_uploaded_8).trigger('change');

      } else {
        $('.step_container.step-8 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="latest_electricity_bill_images"]').val("n/a").trigger('change');
      }

      // step 9
      var step_9_files_uploaded = $('.step_container.step-9 .showThumb .uploaded_file').length;
      if( step_9_files_uploaded > 0 ){
        $('.step_container.step-9 .button_next_previous .next_page').removeClass('disabled');

        var form_uploaded_9 = '';
        $('.step_container.step-9 .showThumb .uploaded_file').each(function(){
          form_uploaded_9 += $(this).find('input').val()+'\n';
        });
        $('.hbspt-form textarea[name="existing_electricity_meter"]').val(form_uploaded_9).trigger('change');
      } else {
        $('.step_container.step-9 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="existing_electricity_meter"]').val("n/a").trigger('change');
      }

      // step 10
      var step_10_files_uploaded = $('.step_container.step-10 .showThumb .uploaded_file').length;
      if( step_10_files_uploaded > 0 ){
        $('.step_container.step-10 .button_next_previous .next_page').removeClass('disabled');

        var form_uploaded_10 = '';
        $('.step_container.step-10 .showThumb .uploaded_file').each(function(){
          form_uploaded_10 += $(this).find('input').val()+'\n';
        });
        $('.hbspt-form textarea[name="switchboard_photo"]').val(form_uploaded_10).trigger('change');
      } else {
        $('.step_container.step-10 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="switchboard_photo"]').val("n/a").trigger('change');
      }

      // step 11
      var step_11_files_uploaded = $('.step_container.step-11 .showThumb .uploaded_file').length;
      if( step_11_files_uploaded > 0 ){
        $('.step_container.step-11 .button_next_previous .next_page').removeClass('disabled');

        var form_uploaded_11 = '';
        $('.step_container.step-11 .showThumb .uploaded_file').each(function(){
          form_uploaded_11 += $(this).find('input').val()+'\n';
        });
        $('.hbspt-form textarea[name="area_around_the_switchboard"]').val(form_uploaded_11).trigger('change');
      } else {
        $('.step_container.step-11 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="area_around_the_switchboard"]').val("n/a").trigger('change');
      }

      // // step 12
      // var step_12_files_uploaded = $('.step_container.step-12 .showThumb .uploaded_file').length;
      // if( step_12_files_uploaded > 0 ){
      //   $('.step_container.step-12 .button_next_previous .next_page').removeClass('disabled');

      //   var form_uploaded_12 = '';
      //   $('.step_container.step-12 .showThumb .uploaded_file').each(function(){
      //     form_uploaded_12 += $(this).find('input').val()+'\n';
      //   });
      //   $('.hbspt-form textarea[name="where_the_solar_battery_will_go"]').val(form_uploaded_12).trigger('change');
      // } else {
      //   $('.step_container.step-12 .button_next_previous .next_page').addClass('disabled');
      //   $('.hbspt-form textarea[name="where_the_solar_battery_will_go"]').val("n/a").trigger('change');
      // }

      // step 12
      var step_12_files_uploaded = $('.step_container.step-12 .showThumb .uploaded_file').length;
      if( step_12_files_uploaded > 0 || $('.step_container.step-12 .fieldset_wrapper .field_content.option_select').hasClass('selected') ){
        var form_uploaded_12 = '';

        if( $('.step_container.step-12 .fieldset_wrapper .field_content.option_select.share_later').hasClass('selected') ){
          form_uploaded_12 = "I'll share this later";
        } else {
          $('.step_container.step-12 .showThumb .uploaded_file').each(function(){
            form_uploaded_12 += $(this).find('input').val()+'\n';
          });
        }

        $('.step_container.step-12 .button_next_previous .next_page').removeClass('disabled');
        $('.hbspt-form textarea[name="access_path_to_your_home"]').val(form_uploaded_12).trigger('change');
      } else {
        $('.step_container.step-12 .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="access_path_to_your_home"]').val("n/a").trigger('change');
      }

      // step 13
      if( $('.step_container.step-13 .fieldset_wrapper .field_content.option_select').hasClass('selected') ) {
        $('.step_container.step-13 .button_next_previous .next_page').removeClass('disabled');
      } else {
        $('.step_container.step-13 .button_next_previous .next_page').addClass('disabled');
      }

      // step 13 - yes
      var step_13_yes_files_uploaded = $('.step_container.step-13-yes .showThumb .uploaded_file').length;
      if( step_13_yes_files_uploaded > 0 ){
        $('.step_container.step-13-yes .button_next_previous .next_page').removeClass('disabled');

        var form_uploaded_13_yes = '';
        $('.step_container.step-13-yes .showThumb .uploaded_file').each(function(){
          form_uploaded_13_yes += $(this).find('input').val()+'\n';
        });
        $('.hbspt-form textarea[name="existing_solar_inverter_photo_or_video"]').val(form_uploaded_13_yes).trigger('change');
      } else {
        $('.step_container.step-13-yes .button_next_previous .next_page').addClass('disabled');
        $('.hbspt-form textarea[name="existing_solar_inverter_photo_or_video"]').val("n/a").trigger('change');
      }

      clearInterval(existFormhbspt_3);
    }
  }, 500);

}